// export default Object.freeze([{
//   id: 1,
//   name: 'Admin'
// },{
//   id: 2,
//   name: 'Moderator'
// },{
//   id: 3,
//   name: 'User'
// }]);


export default Object.freeze({
  ADMIN: {
    id: 1,
    name: 'Admin',
  },
  MODERATOR: {
    id: 2,
    name: 'Moderator'
  },
  USER: {
    id: 3,
    name: 'User'
  },
  SUPERUSER: {
    id: 4,
    name: 'SuperUser'
  },
});